import DateTimePicker from './datetime-picker'

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    DateTimePicker.state
  ),
  mutations: Object.assign(
    DateTimePicker.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/service-selection/index.js